import React from "react";
import { TFunction } from "i18next";

type Props = {
    setIsFidelityArchived: (v: boolean) => void;
    t: TFunction;
};

export default function TabSwitchItems({ setIsFidelityArchived, t }: Props) {
    return (
        <React.Fragment>
            <div
                className="dropdown-item pl-1"
                style={{ cursor: "pointer" }}
                onClick={() => setIsFidelityArchived(false)}
            >
                <span className="ml-2 cmn_btn_BTlistActivated">
                    {t("Fidelity Enabled(s)")}
                </span>
            </div>
            <div
                className="dropdown-item pl-1"
                style={{ cursor: "pointer" }}
                onClick={() => setIsFidelityArchived(true)}
            >
                <span className="ml-2 cmn_btn_BTlistArchived">
                    {t("Archived fidelity(s)")}
                </span>
            </div>
        </React.Fragment>
    );
}
